module.exports = __webpack_public_path__ + "static/media/34pic.e5f91fa7.jpg";